import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { ReactComponent as ArrowDownSVG } from "assets/img/ArrowDown.svg";

import breakpoints from "_constants/breakpoints";

const Content = styled.div`
  min-width: 100%;
  max-width: 100%;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
  width: 100%;
  height: 0;
  opacity: 0;
  transform: scaleY(0);
  transform-origin: 0 0;
  transition: 0.5s ease-in-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      height: 100%;
      opacity: 1;
      transform: scaleY(1);
      margin-bottom: 33px;
      padding: 24px;

      @media (max-width: ${breakpoints.mobileL}) {
        padding: 24px 16px;
      }
    `}
`;
const SectionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #ffffff;
  border: 1px solid #a5aaaf;
  box-sizing: border-box;
  padding: 8px 15px 8px 20px;
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 36px;
  text-align: left;
  color: #03589c;
  transform-origin: 0 0;
  transition: 0.5s ease-in-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      margin-bottom: 24px;
    `}

  @media (max-width: ${breakpoints.mobileL}) {
    line-height: 24px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #ecedf1;
  border-bottom: 1px solid #ecedf1;
  margin-bottom: 32px;

  &:nth-child(2n + 1) {
    background-color: #fafaff;
  }

  &:last-child {
    border-bottom: 1px solid #ecedf1;
  }
`;
const DataRow = styled.div`
  display: flex;
  min-width: 100%;
  padding: 8px 0;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;
const Label = styled.div`
  min-width: 50%;
  width: 50%;
  padding-right: 20px;
  font-weight: normal;
  font-size: 12px;
  text-transform: uppercase;
  color: #7b848d;

  @media (max-width: ${breakpoints.mobileL}) {
    word-break: break-all;
    min-width: 100%;
    width: 100%;
    padding-right: 0;
  }
`;
const Data = styled(Label)`
  font-weight: bold;
  text-transform: none;
  word-break: break-all;
`;
const EmptyMessage = styled.div`
  color: #7b848d;
  font-weight: bold;
  text-align: center;
`;

function CommonLaw({ term, websiteURL }) {
  return (
    <Row>
      <DataRow>
        <Label>TERM</Label>
        <Data>{term || "-"}</Data>
      </DataRow>

      <DataRow>
        <Label>WEBSITE URL</Label>
        <Data>{websiteURL || "-"}</Data>
      </DataRow>
    </Row>
  );
}

CommonLaw.propTypes = {
  term: PropTypes.string,
  websiteURL: PropTypes.string,
};

function CommonLawResultsMobile({ commonLawResults }) {
  const [isOpen, setOpen] = useState(false);

  if (!commonLawResults) return null;

  return (
    <>
      <SectionButton id="common-low-results" isOpen={isOpen} onClick={() => setOpen(!isOpen)}>
        Common Law Results
        <ArrowDownSVG fill="#F37217" transform={isOpen ? "rotate(180)" : undefined} />
      </SectionButton>

      <Content isOpen={isOpen}>
        {commonLawResults.length ? (
          commonLawResults.map((commonLawInfo, idx) => <CommonLaw key={idx} {...commonLawInfo} />)
        ) : (
          <EmptyMessage>No conflicting Common Law results found</EmptyMessage>
        )}
      </Content>
    </>
  );
}

CommonLawResultsMobile.propTypes = {
  commonLawResults: PropTypes.arrayOf(PropTypes.object),
};

export default CommonLawResultsMobile;
